/**
 * Index products — tab switching + product carousel (reference: productsTab mobile + desktop)
 */
(function () {
  const SECTION_SELECTOR = '.index-products.goods';
  const TAB_SELECTOR = '.product-category li';
  const PANEL_SELECTOR = '.index-products__panel';
  const HIDDEN_CLASS = 'hidden';

  let inkBarResizeTimer;
  let inkBarResizeBound;

  function updateTabsInkBar(sectionEl) {
    if (!sectionEl || !(sectionEl instanceof Element)) return;
    const ink = sectionEl.querySelector('[data-index-products-ink-bar]');
    const active = sectionEl.querySelector(
      '.product-category li.ant-tabs-tab-active, .product-category li.current'
    );
    if (!ink || !active) return;

    if (!window.matchMedia('(max-width: 767.98px)').matches) {
      ink.style.removeProperty('width');
      ink.style.removeProperty('transform');
      return;
    }

    const x = active.offsetLeft;
    const w = active.offsetWidth;
    ink.style.width = `${w}px`;
    ink.style.transform = `translate3d(${x}px, 0, 0)`;
  }

  function scheduleInkBarUpdateAll() {
    clearTimeout(inkBarResizeTimer);
    inkBarResizeTimer = setTimeout(() => {
      document.querySelectorAll(SECTION_SELECTOR).forEach(updateTabsInkBar);
    }, 100);
  }

  function ensureInkBarResizeListener() {
    if (inkBarResizeBound) return;
    inkBarResizeBound = true;
    window.addEventListener('resize', scheduleInkBarUpdateAll);
  }

  function padSlideNum(n) {
    return n < 10 ? `0${n}` : String(n);
  }

  function updateProductsPanelUi(panel, swiper) {
    const total = parseInt(panel.dataset.slideCount, 10);
    if (!total || total <= 1 || !swiper) return;

    const idx = swiper.activeIndex;
    const cur = panel.querySelector('[data-products-pagination-current]');
    if (cur) cur.textContent = padSlideNum(idx + 1);

    const prev = panel.querySelector('.index-products__nav--prev');
    const next = panel.querySelector('.index-products__nav--next');
    if (prev) {
      const atStart = idx === 0;
      prev.classList.toggle('is-disabled', atStart);
      prev.toggleAttribute('disabled', atStart);
      prev.classList.toggle(
        'nfsq-site-content-pages-home-components-products-tab-index-prevDisabled',
        atStart
      );
    }
    if (next) {
      const atEnd = idx >= total - 1;
      next.classList.toggle('is-disabled', atEnd);
      next.toggleAttribute('disabled', atEnd);
      next.classList.toggle(
        'nfsq-site-content-pages-home-components-products-tab-index-nextDisabled',
        atEnd
      );
    }
  }

  function initSection(sectionEl) {
    if (!sectionEl) return;

    const tabs = sectionEl.querySelectorAll(TAB_SELECTOR);
    const panels = sectionEl.querySelectorAll(PANEL_SELECTOR);
    const swiperInstances = new Map();

    function showPanel(index) {
      panels.forEach((panel, i) => {
        if (i === index) {
          panel.classList.remove(HIDDEN_CLASS);
          initSwiperForPanel(panel);
        } else {
          panel.classList.add(HIDDEN_CLASS);
          destroySwiperForPanel(panel);
        }
      });

      tabs.forEach((tab, i) => {
        const numSpan = tab.querySelector('.num');
        if (i === index) {
          tab.classList.add('current');
          tab.classList.add('ant-tabs-tab-active');
          if (numSpan) numSpan.style.display = '';
        } else {
          tab.classList.remove('current');
          tab.classList.remove('ant-tabs-tab-active');
          if (numSpan) numSpan.style.display = 'none';
        }
      });

      requestAnimationFrame(() => updateTabsInkBar(sectionEl));
    }

    function initSwiperForPanel(panel) {
      if (!panel || swiperInstances.has(panel)) return;

      const doInit = () => {
        if (swiperInstances.has(panel)) return;

        const wrapper = panel.querySelector('.swiper-wrapper');
        const slides = panel.querySelectorAll('.swiper-slide');
        if (!wrapper || slides.length === 0) return;

        const slideCount = parseInt(panel.dataset.slideCount, 10) || slides.length;
        const hasMulti = slideCount > 1;

        const prevBtn = panel.querySelector('.index-products__nav--prev');
        const nextBtn = panel.querySelector('.index-products__nav--next');

        const options = {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: false,
          watchOverflow: false,
          grabCursor: true,
          allowTouchMove: true,
          pagination: false,
          breakpoints: {
            768: { slidesPerView: 2, spaceBetween: 0 },
            990: { slidesPerView: 3, spaceBetween: 0 },
          },
        };

        if (hasMulti && prevBtn && nextBtn) {
          options.navigation = {
            prevEl: prevBtn,
            nextEl: nextBtn,
          };
        } else {
          options.navigation = false;
        }

        let instance;
        if (typeof window.FoxTheme !== 'undefined' && window.FoxTheme.Carousel) {
          try {
            const carousel = new window.FoxTheme.Carousel(panel, options, []);
            carousel.init();
            instance = carousel;
          } catch (e) {
            instance = initNativeSwiper(panel, options);
          }
        } else {
          instance = initNativeSwiper(panel, options);
        }

        if (instance) {
          swiperInstances.set(panel, instance);
          const swiper = instance.slider || instance;
          if (swiper && typeof swiper.on === 'function') {
            swiper.on('slideChangeTransitionEnd', () => updateProductsPanelUi(panel, swiper));
          }
          if (swiper && typeof swiper.update === 'function') {
            swiper.update();
          }
          updateProductsPanelUi(panel, swiper);
        }
      };

      requestAnimationFrame(() => {
        requestAnimationFrame(doInit);
      });
    }

    function initNativeSwiper(panel, options) {
      const SwiperCtor = window.FoxTheme?.Swiper?.Swiper || window.Swiper;
      if (typeof SwiperCtor !== 'function') return null;
      try {
        const swiper = new SwiperCtor(panel, options);
        return { slider: swiper };
      } catch (e) {
        return null;
      }
    }

    function destroySwiperForPanel(panel) {
      const instance = swiperInstances.get(panel);
      if (instance) {
        const slider = instance.slider || instance;
        if (slider && typeof slider.destroy === 'function') {
          slider.destroy(true, true);
        }
        swiperInstances.delete(panel);
      }
    }

    ensureInkBarResizeListener();

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        showPanel(index);
      });
    });

    showPanel(0);
    requestAnimationFrame(() => updateTabsInkBar(sectionEl));
  }

  function init() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
    scheduleInkBarUpdateAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', (e) => {
    const section = e.target.querySelector(SECTION_SELECTOR);
    if (section) {
      section.querySelectorAll(PANEL_SELECTOR).forEach((panel) => {
        const instance = panel._swiperInstance;
        if (instance && typeof instance.destroy === 'function') {
          instance.destroy(true, true);
        }
      });
    }
  });
})();
